import { useEffect } from 'react';
import { Box, useSteps } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { updateBackAction } from '../../../../redux/providerBuilder/stepperDetails';
import { getBackAction } from '../../../../redux/providerBuilder/stepperDetails/selectors';
import { ProviderName } from './provider-name.component';
import { RequestConfig } from './request-config.component';

/* eslint-disable indent */
  export const StepperForm = () => {
  const dispatch = useAppDispatch();

  const backActionUsed = useAppSelector(getBackAction);

  const steps = ['Basic Details', 'Provider Configurations'];

  const { activeStep: activeStepInnerForm, setActiveStep: setActiveStepInnerForm } =
    useSteps({
      index: 0,
      count: steps.length,
    });

  useEffect(() => {
    if (backActionUsed) {
      setActiveStepInnerForm(1);
      dispatch(updateBackAction(false));
    }
  }, [backActionUsed, dispatch]);



  return (
    <>
      <Box>
        {activeStepInnerForm === 0 && (
          <RequestConfig setActiveStepInnerForm={setActiveStepInnerForm} />
        )}
        {activeStepInnerForm === 1 && (
          <ProviderName setActiveStepInnerForm={setActiveStepInnerForm} />
        )}
      </Box>
    </>
  );
};
